export type { DomainListEntry } from './domains';
export { getDomainsForEnv, getDomainForLocale } from './domains';
export {
  defaultLocale,
  supportedLocales,
  generateFallbackLng,
  getReleasedCountries,
  getReleasedDomains,
  getDefaultLocaleForDomain,
  getLocalesForDomain,
  getLocalesForCountry,
  getCountryForLocale,
  getCountriesForDomain,
  isGtmEnabledForLocale,
  getPiwikId,
  getDomainsWithMultipleLanguages,
  isVATEnabledForLocale,
} from './locales';
export { translations } from './generated/translations';
export type { Translations } from './generated/translations';
export { default as locales } from './resources/locales.json';
export type { LocaleItem, CountryItem, ContinentItem } from './data';
